
import { Component, Vue } from 'vue-property-decorator';
import { WPXFormValue } from '@/components/templates/WPXForm';
import { EditScoreTypeForm } from '@/services/QA/scoreType/forms/EditScoreTypeForm';
import { ScoreTypeInterface, ScoreTypeRepositoryInterface } from '@/services/QC-V2/score-type/interfaces';

@Component({
  inject: [
    'scoreTypeRepositoryV2',
  ],
})
export default class EditScoreType extends Vue {
  private scoreType!: ScoreTypeInterface;
  private readonly scoreTypeRepositoryV2!: ScoreTypeRepositoryInterface;
  private loading: boolean = true;
  private form: WPXFormValue<EditScoreTypeForm> = new WPXFormValue(EditScoreTypeForm);


  public async created(): Promise<void> {
    await this.initialize();
    this.loading = false;
  }

  private async initialize(): Promise<void> {
    if (!this.$route.params.scoreTypeId) {
      this.$errorDialog.show('Score Type Id Not Provided!');
      return;
    }

    this.scoreType = await this.scoreTypeRepositoryV2.getOneById(Number(this.$route.params.scoreTypeId));
    this.form.data.label = this.scoreType.label;
  }

  private async editScoreType(): Promise<void> {
    try {
      await this.scoreTypeRepositoryV2.updateScoreType(this.scoreType.id, {
        label: this.form.data.label,
      });

      this.$successDialog.show(`Score Type '${this.form.data.label}' has been edited`);
      await this.$router.push({ name: 'scores' });
    } catch (err) {
      this.$errorDialog.show(err.response?.data?.message);
    }
  }
}
